import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { display, height as heightUtil, maxWidth, width as widthUtil } from 'styled-system';

import { LazyImage } from 'common/components/LazyImage';
import { placeholderThumbnail } from 'common/utils/placeholderThumbnail';

interface LinkSectionListItemImageProps {
  width: number;
  height: number;
  src: string;
  alt: string;
}

const UnstyledLinkSectionImage = styled.img<any>`
  ${widthUtil};
  ${heightUtil};
  ${display};
  ${maxWidth};
`;

const LinkSectionImage = (props: ComponentProps<typeof UnstyledLinkSectionImage>) => (
  <UnstyledLinkSectionImage display="block" maxWidth="100%" {...props} />
);

const LinkSectionListItemImage = ({ width, height, src, alt }: LinkSectionListItemImageProps) => (
  <LazyImage x1={src}>
    {({ loaded, image, innerRef }) => (
      <LinkSectionImage
        data-testid="link-section-image"
        data-visual-test="transparent"
        width={width}
        height={height}
        alt={alt}
        ref={innerRef}
        src={loaded ? image : placeholderThumbnail(width, height)}
      />
    )}
  </LazyImage>
);

export default LinkSectionListItemImage;
